module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_5010.77f07ce0.png";